import { Flex } from "@fluentui/react-northstar";
import { DateRangePickerOneMonth } from "../../../../components/DateRangePicker/DateRangePickerOneMonth";
import { DropdownFilter } from "../../../hr_documents/styles/index.styles";

const FilterExpensesForm = () => {
    // filtres

    return (
        <Flex wrap styles={{ gap: "10px" }}>
            {/* dates (start & end) */}
            <Flex>
                <DateRangePickerOneMonth
                    defaultStartDate={"2026-02-1"}
                    defaultEndDate={"2026-02-20"}
                    resetDatesToNull={() => {}}
                    onDatesChange={() => {}}
                />
            </Flex>
            {/* type d'absence */}
            <Flex>
                <DropdownFilter
                    className="category"
                    placeholder="Choisir un azdazdazd"
                    items={[]}
                    onChange={() => {}}
                    value={[]}
                    multiple
                    inverted
                    fluid
                    search
                    width={"206px"}
                />
            </Flex>
            {/* facturable ou pas  */}
            <Flex>
                <DropdownFilter
                    className="category"
                    placeholder="Facturable ou pas"
                    items={["facturable", "non facturable"]}
                    onChange={() => {}}
                    value={[]}
                    multiple
                    inverted
                    fluid
                    search
                    width={"206px"}
                />
            </Flex>
            {/* départments list */}
            <Flex>
                <DropdownFilter
                    className="category"
                    placeholder="Départements"
                    items={["département 1", "département 2", "département 3"]}
                    onChange={() => {}}
                    value={[]}
                    multiple
                    inverted
                    fluid
                    search
                    width={"206px"}
                />
            </Flex>
            {/* collaborateur */}
            <Flex>
                <DropdownFilter
                    className="category"
                    placeholder="Collaborateurs"
                    items={[
                        "collaborateur 1",
                        "collaborateur 2",
                        "collaborateur 3",
                    ]}
                    onChange={() => {}}
                    value={[]}
                    multiple
                    inverted
                    fluid
                    search
                    width={"206px"}
                />
            </Flex>
            {/* manager */}
            <Flex>
                <DropdownFilter
                    className="category"
                    placeholder="Managers"
                    items={["manager 1", "manager 2", "manager 3"]}
                    onChange={() => {}}
                    value={[]}
                    multiple
                    inverted
                    fluid
                    search
                    width={"206px"}
                />
            </Flex>
        </Flex>
    );
};

export default FilterExpensesForm;
